<header
  class="d-flex align-items-center header-desktop"
  #header
  [@openClose]="basePanelService.isExpanded()"
  [class.expanded]="basePanelService.sideManuallyExpanded()"
>
  <nav class="h-100 w-100">
    <div class="nav-items">
      <div class="logo-wrapper" [class.expanded]="basePanelService.isExpanded()">
        <header-logo [hidden]="isCollapsed()" />
        <svg-icon
          [class.expanded]="basePanelService.sideManuallyExpanded()"
          (click)="basePanelService.toggleMenu()"
          src="/assets/img/arrow-left-white.svg"
        />
      </div>

      <div class="nav-wrapper">
        <div *ngIf="store.isLogged" class="nav-links">
          <ng-container *ngFor="let tabLink of tabLinks; let index = index">
            <a
              draggable="false"
              [routerLink]="n.getPath(tabLink.link)"
              [routerLinkActive]="['new-link--active']"
              [ngClass]="{ 'new-link--active2': isTimelineRoute(tabLink) }"
              class="new-link"
              *ngIf="!tabLink.hidden"
              data-type="tab"
              id="tab{{ index }}"
              [matTooltip]="isCollapsed() ? (tabLink.name | translate) : ''"
              matTooltipPosition="right"
            >
              <svg-icon [src]="tabLink.iconUrl" [title]="tabLink.name | translate" />
              <span
                [innerHTML]="tabLink.name | translate"
                [hidden]="isCollapsed()"
                class="new-link__text"
                [class.expanded]="isFullyExpanded()"
              ></span>
            </a>
          </ng-container>
        </div>
        <div *ngIf="store.isLogged" class="nav-bottom">
          <ng-container *ngIf="!isCollapsed()">
            <button
              *appHasRole="adminRoles"
              type="button"
              class="new-link new-link__btn privacy-toggle"
              [class.privacy-toggle--on]="privacyMode.enabled()"
              [matMenuTriggerFor]="privacyMenu"
            >
              <svg-icon
                [src]="privacyMode.enabled() ? '/assets/img/ic-eye-off.svg' : '/assets/img/ic-eye-outline.svg'"
              />
              <span class="new-link__text" [class.expanded]="basePanelService.isExpanded()">{{
                'Header.privacyMode' | translate
              }}</span>
              <span class="privacy-toggle__switch" aria-hidden="true"></span>
            </button>
          </ng-container>
          <button
            id="createMenu"
            *appHasRole="defaultPanelRoles"
            [matMenuTriggerFor]="createMenu"
            class="new-link new-link__btn"
            [class.new-link__btn--collapsed]="isCollapsed()"
          >
            <svg-icon src="/assets/img/plus-icon.svg" />
            <span
              class="new-link__text"
              [class.expanded]="basePanelService.isExpanded()"
              [hidden]="isCollapsed()"
              >{{ 'Header.create' | translate }}</span
            >
          </button>
          <div>
            <header-action-menu-user [isExpanded]="isFullyExpanded()" />
          </div>
        </div>
        <div *ngIf="!store.isLogged" class="nav-bottom">
          <button
            class="new-link new-link__btn new-link__btn--white"
            (click)="n.go('login'); !!headerService.isMenuOpen ? headerService.closeMenu() : null"
          >
            <svg-icon src="/assets/img/new-arrow-right.svg" />
            <span
              class="new-link__text new-link__text--blue"
              [class.expanded]="basePanelService.isExpanded()"
              [hidden]="isCollapsed()"
            >
              {{ 'Auth.Login.signIn' | translate }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </nav>
</header>

<!-- Mobile header -->
<header class="header-mobile">
  <nav class="container-fluid w-100">
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between p-0">
        <div class="d-flex align-items-center">
          <header-hamburger />
          <header-logo (click)="!!headerService.isMenuOpen ? headerService.closeMenu() : null" />
        </div>
        <header-action-menu
          (click)="!!headerService.isMenuOpen ? headerService.closeMenu() : null"
          *ngIf="store.isLogged"
        />
        <app-button
          *ngIf="!store.isLogged"
          class="mr-2"
          (click)="n.go('login'); !!headerService.isMenuOpen ? headerService.closeMenu() : null"
          [config]="{
            text: 'Auth.Login.signIn' | translate,
            type: ButtonTypes.PRIMARY_WHITE
          }"
        />
      </div>
    </div>
  </nav>
</header>

<div [@enterAnimation] *ngIf="headerService.isMenuOpen" class="ui-mobile-nav">
  <div class="mobile-navigation-tabs">
    <div class="row justify-content-center">
      <ng-container *ngFor="let tabLink of tabLinks; let index = index">
        <a
          draggable="false"
          [routerLink]="n.getPath(tabLink.link)"
          [routerLinkActive]="['mobile-navigation-tabs-tab--active']"
          class="mobile-navigation-tabs-tab"
          (click)="headerService.closeMenu()"
          data-type="tab"
          [id]="'tab' + index"
        >
          <svg-icon [src]="tabLink.iconUrl" />
          <span [innerHTML]="tabLink.name | translate" class="mobile-navigation-tabs-tab-text"></span>
        </a>
      </ng-container>
    </div>
    <div>
      <div class="mobile-navigation-create">
        <app-button
          [class]="'btn-block font-16'"
          [matMenuTriggerFor]="createMenu"
          [config]="{
            type: ButtonTypes.PRIMARY_GREEN,
            size: ButtonSize.LARGE,
            text: 'Header.create' | translate
          }"
        />
      </div>
    </div>
  </div>
</div>

<mat-menu #privacyMenu="matMenu" yPosition="above" class="menu-v2">
  @for (mode of privacyModes; track mode) {
    <button mat-menu-item [class.privacy-menu-item--active]="privacyMode.mode() === mode" (click)="privacyMode.setMode(mode)">
      <span>{{ 'Header.privacy.' + mode | translate }}</span>
    </button>
  }
</mat-menu>

<mat-menu #createMenu="matMenu" yPosition="above" class="mt-1" class="menu-v2">
  <button mat-menu-item (click)="createContact()">
    <span>{{ 'Header.CreateOptions.contact' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createProjectDraft()">
    <span>{{ 'Header.CreateOptions.project' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createTask()">
    <span>{{ 'Header.CreateOptions.task' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createTask(TaskType.TYPE_CORRECTION)">
    <span>{{ 'TaskType.correction' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createTask(TaskType.TYPE_ORDER)">
    <span>{{ 'TaskType.order' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createChange()">
    <span>{{ 'Header.CreateOptions.change' | translate }}</span>
  </button>

  <button mat-menu-item (click)="createEvent()">
    <span>{{ 'CalendarEvents.event' | translate }}</span>
  </button>
</mat-menu>
